import * as React from "react"

const MOBILE_BREAKPOINT = 1024 // Augmenté de 768 à 1024

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const detectMobile = () => {
      // Combinaison de plusieurs méthodes pour une meilleure détection
      const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
      const userAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      const screenWidth = window.innerWidth < MOBILE_BREAKPOINT
      const smallHeight = window.innerHeight < 600 // Détection des écrans courts
      
      // Un appareil est considéré comme mobile s'il a :
      // - Le support tactile ET une largeur < 1024px
      // - OU un user agent mobile
      // - OU une largeur < 600px (très petits écrans)
      return (hasTouch && screenWidth) || userAgent || window.innerWidth < 600 || (hasTouch && smallHeight)
    }

    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(detectMobile())
    }
    mql.addEventListener("change", onChange)
    setIsMobile(detectMobile())
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}
